/* globals process */

export default () => {
  // function contents go here
  if ($('.find-a-group-search').length) {

    const $input = $('#find-a-group-search-form-input'),
          $submitBtn = $('.find-a-group-search-form-submit'),
          $resultsContainer = $('.find-a-group-search-results'),
          $loader = $('.find-a-group-search-results-loader');

    $submitBtn.on('click', (e) => {
      e.preventDefault();
      const searchValue = $input.val();

      if (searchValue.length > 1) {

        // empty out results container and set loading
        $resultsContainer.empty();
        $loader.show();

        // fetch data
        fetch(`${process.env.FIND_A_GROUP_ENDPOINT}?zip=${searchValue}`)
          .then(res => res.json())
          .then(data => {
            const results = data.results[0];

            // markup if no results
            if (results.length === 0 || !results || results === undefined) {
              $resultsContainer.html(`
              <div class="find-a-group-search-no-results h2">No results were found. Please enter a different ZIP Code.</div>
              `);
              return;
            }

            // configure region name data
            if (results.RegionName) {
              const barIndex = results.RegionName.indexOf('|');

              results.RegionNameSplit = results.RegionName.slice(barIndex + 1);

              results.RegionName = results.RegionName.replace('|', '-');
            }

            // if results exist then hide loader
            $loader.hide();

            // results template
            $resultsContainer.html(`
            <div class="find-a-group-search-results-loader loader"></div>
            <div class="find-a-group-search-results-title h5">
              <span>Results for</span>
              <span class="-region">${searchValue} - ${results.RegionNameSplit}</span>
            </div>
            <div class="find-a-group-search-results-data">
              ${ results.regionName ? `<div class="eyebrow find-a-group-search-results-data-region">${results.RegionName}</div>` : ''}  
              ${ results.SectionName ? `<div class="find-a-group-search-results-data-link">
              <a href="${results.SectionLink}" class="-underline h6">${results.SectionName}</a>
            </div>` : ''}
              ${ results.BranchCount ? `<div class="find-a-group-search-results-data-branches"><span>${results.BranchCount}</span> active branches</div>` : ''}
              ${ results.CommitteesCount ? `<div class="find-a-group-search-results-data-committees"><span>${results.CommitteesCount}</span> active committees</div>` : ''}
            `);
          });
      }
    });
  }
};
